import styled from 'styled-components'

export const AuthorContainer = styled.div`
  width: 100%;
  max-width: 1170px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 200px;
  padding: 0 16px;
  margin: 100px 0;

  .card-author {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    max-width: 558px;
    max-height: 143px;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.colors.primary_5};
    border-radius: 8px;
    padding: 19px 10px 19px 70px;

    .avatar {
      position: absolute;
      left: -8rem;
      border-radius: 100%;
    }

    @media (max-width: 791px) {
      max-width: 360px;
      .avatar {
        left: -3rem;
      }
    }
    @media (max-width: 480px) {
      padding: 10px 10px 10px 70px;
      max-width: 320px;
      .avatar {
        left: -1rem;
      }
    }
  }

  @media (max-width: 760px) {
    gap: 100px;
  }

  @media (max-width: 480px) {
    gap: 50px;
  }
`
